/*eslint-env jquery*/
class HtmlPageService {
  scrollElement(jQuerySelector, pixelsFromTop, continueWith) {
    var $j = jQuery.noConflict();
    if (!pixelsFromTop)
      pixelsFromTop = 0;

    var navbar = $j("#header");
    var navbarHeight = navbar.length === 0 ? 0 : navbar.height();
    var element = $j(jQuerySelector);

    if (element.length === 0) return; //if we have no elements -> do nothing 
    var domElement = element[0];

    if (window.top) {
      window.top.postMessage("scroll into view: " + jQuerySelector, "*");
      return;
    }

    //if element is already visible -> do nothing (prevent from scrolling up/down an already visible element)
    if (this.isScrolledIntoView(domElement)) return;
        
    var offset = $j(jQuerySelector).offset();
    let newValue = offset.top - pixelsFromTop - navbarHeight;
    if (!$j("body,html").animate) {
      $j("body,html").scrollTop(newValue);
      $j("body,html").scrollLeft(offset.left);
      return;
    }
        
    $j("body,html").animate({
      scrollTop: newValue, //offset.top - pixelsFromTop - navbarHeight,
      scrollLeft: offset.left
    }, 500, continueWith);
  }

  isScrolledIntoView(elem) {
    var $j = jQuery.noConflict();
    var docViewTop = $j(window).scrollTop();
    var docViewBottom = docViewTop + $j(window).height();

    var elemTop = $j(elem).offset().top;
    var elemBottom = elemTop + $j(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  loadScript(url, callback) {
    var script = document.createElement("script")
    script.type = "text/javascript";
    if (script.readyState) {  // only required for IE <9
      script.onreadystatechange = function () {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function () {
        callback();
      };
    }
      
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }      
}

export default new HtmlPageService();